import { useGetFeatureFlagsQuery } from '@/services/ApiService';

export const useFeatureFlags = () => {
    const { data, isFetching, isError } = useGetFeatureFlagsQuery();

    return {
        featureFlags: data || {},
        isFetching,
        isError,
    };
};
